import { GuildProjectSlugs } from '@/services/GuildSignupPageService'
import { removeFromSessionStorage, writeToSessionStorage } from '../session-storage'

export function projectSlugsAttribution(projectSlugs: GuildProjectSlugs | undefined): void {
  const joinedSlugs = projectSlugs?.projectSlugs?.join(',')
  if (joinedSlugs) writeToSessionStorage('projectSlugs', joinedSlugs)
  else removeFromSessionStorage('projectSlugs')
}
